"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
var _typeof = require("@babel/runtime/helpers/typeof");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _objectSpread2 = _interopRequireDefault(require("@babel/runtime/helpers/esm/objectSpread2"));
var _react = _interopRequireWildcard(require("react"));
var _makeStyles = _interopRequireDefault(require("@mui/styles/makeStyles"));
var _Dialog = _interopRequireDefault(require("@mui/material/Dialog"));
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != _typeof(e) && "function" != typeof e) return { default: e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && {}.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n.default = e, t && t.set(e, n), n; }
var useStyles = (0, _makeStyles.default)(function (theme) {
  return {
    paper: {
      backgroundColor: theme.palette.background3,
      minWidth: 400,
      borderRadius: 2,
      padding: "50px"
    },
    header: {
      textAlign: "center",
      marginBottom: 25
    },
    closeDiv: {
      marginTop: theme.spacing(-2),
      marginRight: theme.spacing(-6)
    },
    title: (0, _objectSpread2.default)({}, theme.typography.h2, {
      margin: 0
    })
  };
});
var HiDialog = function HiDialog(props) {
  var content = props.content,
    id = props.id,
    onClose = props.onClose,
    open = props.open,
    title = props.title;
  var classes = useStyles(props);
  var handleClose = (0, _react.useCallback)(function () {
    if (onClose) {
      onClose();
    }
  }, [onClose]);
  return /*#__PURE__*/_react.default.createElement(_Dialog.default, {
    classes: {
      paper: classes.paper
    },
    onClose: handleClose,
    id: id,
    open: open
  }, /*#__PURE__*/_react.default.createElement("div", {
    className: classes.header
  }, typeof title === "string" ? /*#__PURE__*/_react.default.createElement("p", {
    className: classes.title
  }, title) : title), /*#__PURE__*/_react.default.createElement("div", null, content));
};
var _default = exports.default = HiDialog;